export const Badge = ({ children, className = 'badge-gray', dot = true }) => (
  <span className={`badge ${className}`}>
    {dot && <span className="badge-dot" />}
    {children}
  </span>
);

export const StatusBadge = ({ status, config }) => {
  const c = config[status] || { label: status, cls: 'badge-gray' };
  return <Badge className={c.cls}>{c.label}</Badge>;
};
